import { Colors } from '@nakedplatform/ui';
import { PageProps } from 'components/page/head';
import { AppLinks, ContactDetails, Legals, Logo, Nav, SocialMediaLinks } from './components';
import { FooterContainer, StyledFooter } from './styles';

import React from 'react';
/**
 * Renders the footer component
 *
 * @param props - Footer props
 */
export function Footer(props: PageProps) {
  const { cornerColorMobile = Colors.green, cornerColorDesktop = Colors.green } = props;

  return (
    <StyledFooter cornerColorMobile={cornerColorMobile} cornerColorDesktop={cornerColorDesktop}>
      <FooterContainer>
        <Logo />
        <Nav />
        <AppLinks />
        <SocialMediaLinks />
        <ContactDetails />
        <Legals />
      </FooterContainer>
    </StyledFooter>
  );
}
